import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import './programaPuntos.scss'

const TARGET = 10

const ProgramaPuntos = ({ programaPuntos }) => {
  const { t } = useTranslation()

  if (!programaPuntos || typeof programaPuntos.count !== 'number') {
    return null
  }

  const { count } = programaPuntos
  const remaining = TARGET - count

  return (
    <div className="programa-puntos">
      <div className="programa-puntos__header">
        <span className="programa-puntos__title">
          {t('carrito.programa-puntos.title')}
        </span>
        <span className="programa-puntos__counter">
          {count}/{TARGET}
        </span>
      </div>

      <span className="programa-puntos__message">
        {count === 0
          ? t('carrito.programa-puntos.empieza')
          : remaining === 1
            ? t('carrito.programa-puntos.falta-una')
            : t('carrito.programa-puntos.faltan', { count: remaining })}
      </span>

      <div className="programa-puntos__dots" aria-hidden="true">
        {Array.from({ length: TARGET }).map((_, index) => (
          <span
            key={index}
            className={`programa-puntos__dot${
              index < count ? ' programa-puntos__dot--filled' : ''
            }`}
          />
        ))}
      </div>
    </div>
  )
}

ProgramaPuntos.propTypes = {
  programaPuntos: PropTypes.shape({
    count: PropTypes.number,
  }),
}

export default ProgramaPuntos
